import { TrendingUp, Users, Instagram, Activity, Building2, HeartHandshake } from "lucide-react";
import CountUp from "./CountUp";

const IMPACTO = [
  { icon: Instagram, n: 5487, prefix: "+", v: "Seguidores no Instagram do Instituto", accent: "text-ga-emerald" },
  { icon: Instagram, n: 12214, prefix: "+", v: "Seguidores no perfil ENAGA", accent: "text-blue-600" },
  { icon: Users, k: "Dezenas", v: "Jovens atendidos todos os dias", accent: "text-ga-amber_deep" },
  { icon: Building2, n: 13, v: "Espaços terapêuticos e psicológicos, quadras, futebol society, hidroterapias e centro de saúde", accent: "text-purple-600" },
  { icon: Activity, n: 4, v: "Frentes de atuação: esporte, educação, saúde e inclusão social", accent: "text-ga-emerald" },
  { icon: HeartHandshake, k: "TEA", v: "Apoio a crianças com neurodiversidade", accent: "text-blue-600" },
];

export default function NossoImpacto() {
  return (
    <section
      id="nosso-impacto"
      data-testid="nosso-impacto-section"
      className="section-pad bg-ga-ink text-white relative overflow-hidden"
    >
      <div className="absolute top-20 left-10 w-80 h-80 rounded-full bg-ga-emerald/20 blur-3xl" />
      <div className="absolute bottom-10 right-10 w-96 h-96 rounded-full bg-ga-amber/15 blur-3xl" />

      <div className="container-ga relative">
        <div className="max-w-3xl">
          <div className="pill border-white/20 text-white/80 bg-white/5 mb-6" data-testid="nosso-impacto-pill">
            <TrendingUp className="w-3.5 h-3.5" />
            Nosso impacto
          </div>
          <h2 className="font-display font-black tracking-tighter text-4xl sm:text-5xl lg:text-6xl leading-[1.02]">
            Números que contam o <span className="text-ga-amber">tamanho</span> do Instituto.
          </h2>
          <p className="mt-5 text-white/75 text-lg leading-relaxed max-w-2xl">
            Cada métrica é também um encontro, um atendimento, um sorriso. Aqui
            a transformação é contada em pessoas e em evidências.
          </p>
        </div>

        <div className="mt-12 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4" data-testid="nosso-impacto-grid">
          {IMPACTO.map((item, i) => (
            <article
              key={item.v}
              data-testid={`impacto-card-${i}`}
              className="rounded-3xl bg-white/[0.04] border border-white/10 p-7 hover:bg-white/[0.07] transition-colors"
            >
              <item.icon className={`w-6 h-6 ${item.accent}`} />
              <div className="mt-4 font-display font-black text-5xl text-white leading-none tracking-tight tabular-nums">
                {typeof item.n === "number" ? (
                  <>{item.prefix || ""}<CountUp to={item.n} duration={1600} /></>
                ) : (
                  item.k
                )}
              </div>
              <div className="mt-3 text-sm text-white/65 leading-snug">{item.v}</div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
